import React, {Fragment} from "react";
import AnalyticsContext from "./AnalyticsContext";
import AB_Users from "./Components/AB_Users";
import AB_Ads from "./Components/AB_Ads";
import withURLParams from "../common/SiteWithUrlParams";
import AB_Ratings from "./Components/AB_Ratings";
import withFilter from "./SiteWithFilter";
import AB_Revenue from "./Components/AB_Revenue";
import LoadingBannerUI from "../common/LoadingBannerUI";
import EventFunnel_Bar from "./Components/EventFunnel_Bar";
import {formatDate} from "../common/TimeUtil";
class FunnelsPage extends React.Component {
    constructor(_props) {
        super(_props);

        this.state = {
            isLoading : false
        };

        this.loadingBanner = this.loadingBanner.bind(this);
        this.renderFunnel = this.renderFunnel.bind(this);
        this.renderGraphs = this.renderGraphs.bind(this);
    }


    componentDidMount() {
        this._ctx = AnalyticsContext.getSubContext();
        this.setState({isLoading : true});
        this._ctx.getGameSettings(this.props.urlParams.gameId, (_err, _games) => {
            this.setState((_prevState, _props)=>{return {isLoading: false, funnels : _games.funnels};});
            if (this.props.extraFilters && typeof this.props.extraFilters === "function") {
                let funnels = [];
                for(let i = 0; i < _games.funnels.length; i++) {
                    const funnel = _games.funnels[i];
                    funnels.push(funnel.name);
                }
                this.props.extraFilters({funnel : funnels});
            }
        });
    }

    componentWillUnmount() {
        this._ctx.clear();
    }

    loadingBanner() {
        if (this.state.isLoading) {
            return (<LoadingBannerUI text={"Loading User Data"} />);
        }
        return null;
    }

    renderGraphs() {
        let params = null;
        if (this.props.funnel && this.state.funnels) {
            for(let i = 0; i< this.state.funnels.length; i++) {
                if (this.state.funnels[i].name === this.props.funnel) {
                    params = this.state.funnels[i];
                    break;
                }
            }
        }
        if (params === null) {
            return null;
        } else {
            let filter = {};
            if (this.props.filter) {
                filter = JSON.parse(JSON.stringify(this.props.filter));
            }
            filter.game_id = this.props.urlParams.gameId;
            const startDate = formatDate(this.props.dateSelection.start);
            const endDate = formatDate(this.props.dateSelection.end);
            return (
                <Fragment>
                    <EventFunnel_Bar startDate={startDate} endDate={endDate} filter={filter} events={params.events} funnelName={this.props.funnel} />
                </Fragment>
            )
        }
    }

    renderFunnel() {

        if(!this.state.isLoading) {
            return (
                <Fragment>
                    {this.renderGraphs()}
                </Fragment>
            )
        }
        else return null;
    }

    render() {
        return (
            <Fragment>
                {this.loadingBanner()}
                {this.renderFunnel()}
            </Fragment>
        );
    }
}

export default withURLParams(withFilter(FunnelsPage,["time","filter"], (_props)=> {return "Funnels "+AnalyticsContext.getGameName(_props.urlParams.gameId);}));